// extracted by mini-css-extract-plugin
export var answer = "faq-module--answer--b5d9b";
export var faq = "faq-module--faq--f1284";
export var question = "faq-module--question--c67fe";